import { FeatureFlags, Permission } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS } from '../../../../../../types';

const path = PAGE_PATHS.INCIDENT_LIFECYCLE;

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/settings/incident-lifecycle/')({
  beforeLoad: ({ context, preload }) => {
    const allowedFFIncidentLifecycle = !!context.featureFlags[FeatureFlags.IncidentLifecycle];
    const isAllowed = context.userPermissions.hasAllowedPermission({ path, permission: Permission.READ }) && allowedFFIncidentLifecycle;
    context.validatePermissions({ isAllowed, preload });
  },
});
